import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ItemCollection} from './item-collection';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import * as classTransformer from 'class-transformer';
import {Item} from './item';
import {PlanningParameterItem} from '../planning-parameter-item/planning-parameter-item';

@Injectable({
    providedIn: 'root',
})
export class ItemService {

    constructor(private httpClient: HttpClient) {
    }

    public find(search: string): Observable<ItemCollection> {
        const params = new HttpParams().set('search', search);

        return this.httpClient
            .get('/items', {params})
            .pipe(map((result: any) => {
                const collection = new ItemCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setItems(
                    result['member'].map((itemData: any) => classTransformer.plainToInstance(Item, itemData))
                );

                return collection;
            }));
    }

    public findByIds(items: PlanningParameterItem[]): Observable<ItemCollection> {
        const params = new HttpParams().set('ids', items.map(ppItem => ppItem.id).join(','));

        return this.httpClient
            .get('/items', {params})
            .pipe(map((result: any) => {
                const collection = new ItemCollection();
                collection.setTotalItems(result['totalItems']);
                collection.setItems(
                    result['member'].map((itemData: any) => classTransformer.plainToInstance(Item, itemData))
                );

                return collection;
            }));
    }
}
